var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-0",class:_vm.parentClass,attrs:{"data-role":_vm.role}},[(_vm.caption)?_c('b',{domProps:{"textContent":_vm._s(_vm.caption)}}):_vm._e(),_c('span',{staticClass:"d-block",domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }